/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StringFacetValue } from './StringFacetValue';
import {
    StringFacetValueFromJSON,
    StringFacetValueFromJSONTyped,
    StringFacetValueToJSON,
} from './StringFacetValue';

/**
 * 
 * @export
 * @interface FacetModel
 */
export interface FacetModel {
    /**
     * 
     * @type {string}
     * @memberof FacetModel
     */
    id?: string;
    /**
     * 
     * @type {Array<StringFacetValue>}
     * @memberof FacetModel
     */
    values?: Array<StringFacetValue>;
    /**
     * 
     * @type {string}
     * @memberof FacetModel
     */
    title?: string;
}

/**
 * Check if a given object implements the FacetModel interface.
 */
export function instanceOfFacetModel(value: object): boolean {
    return true;
}

export function FacetModelFromJSON(json: any): FacetModel {
    return FacetModelFromJSONTyped(json, false);
}

export function FacetModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacetModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(StringFacetValueFromJSON)),
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function FacetModelToJSON(value?: FacetModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'values': value['values'] == null ? undefined : ((value['values'] as Array<any>).map(StringFacetValueToJSON)),
        'title': value['title'],
    };
}

